import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { Positions2PanelComponent } from './lib/positions-2-panel.component'
import { Positions2Key } from './panel-key'

export * from './lib/positions-2.module'
export * from './panel-key'

export const Positions2PanelConfig: PanelConfig = {
  key: Positions2Key,
  title: 'Positions 2.0',
  description:
    'Compare and reconcile positions across Enfusion, Prometheus and Clearwater in one configurable workbench.',
  category: PanelCategory.ESSENTIALS,
  panelComponent: Positions2PanelComponent,
  // Ungated for now; permission gating is tracked separately.
  accessPermission: undefined,
  // Still being built out: available on alpha/beta/stg, withheld from production.
  hideInProduction: true,
}
